// extracted by mini-css-extract-plugin
export var actions = "CompleteProfileWidget-module--actions--7Q0Bh";
export var container = "CompleteProfileWidget-module--container---vVcn";
export var message = "CompleteProfileWidget-module--message--9-+4s";
export var messageTitle = "CompleteProfileWidget-module--messageTitle--yEOq3";
export var percentage = "CompleteProfileWidget-module--percentage--IureT";
export var rocketIcon = "CompleteProfileWidget-module--rocketIcon--b1ZtR";